export default __webpack_public_path__ + "static/6-92c695ddc571c2243ca10c585cbb6cf8.webp";